module.exports = "<div class=\"image-hspinner\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/shared/hspinner.component.html
// module id = 374
// module chunks = 0